module.exports = __webpack_public_path__ + "assets/img/app-store.5cda2358.svg";